// Single catalog for web, iPhone, validation, and the shared card renderer.
// Keep IDs stable so existing cards continue to open. Pattern numbers select shared shader motifs.
export const cardDesignFamilies = [
  { id: 'space', label: 'Space' },
  { id: 'liquid', label: 'Liquid' },
  { id: 'gradient', label: 'Gradient' },
  { id: 'fullcolor', label: 'Full color' },
  { id: 'duotone', label: 'Duotone' },
  { id: 'glass', label: 'Glass' },
  { id: 'livingglass', label: 'Living Glass' },
  { id: 'snazzy', label: 'Snazzy' },
] as const;
export const cardDesigns ={
  "duotone-red-white": {"name":"Red on white","family":"duotone","background":"#ffffff","foreground":"#bc2430","accent":"#bc2430","muted":"#bc2430","surface":"#bc243014","theme":"stone","colors":["#ffffff","#ffffff","#ffffff","#ffffff"],"pattern":0,"lightInk":false},
  "duotone-white-red": {"name":"White on red","family":"duotone","background":"#bc2430","foreground":"#ffffff","accent":"#ffffff","muted":"#ffffff","surface":"#ffffff14","theme":"ink","colors":["#bc2430","#bc2430","#bc2430","#bc2430"],"pattern":0,"lightInk":true},
  "duotone-blue-white": {"name":"Blue on white","family":"duotone","background":"#ffffff","foreground":"#173f80","accent":"#173f80","muted":"#173f80","surface":"#173f8014","theme":"stone","colors":["#ffffff","#ffffff","#ffffff","#ffffff"],"pattern":0,"lightInk":false},
  "duotone-white-blue": {"name":"White on blue","family":"duotone","background":"#173f80","foreground":"#ffffff","accent":"#ffffff","muted":"#ffffff","surface":"#ffffff14","theme":"ink","colors":["#173f80","#173f80","#173f80","#173f80"],"pattern":0,"lightInk":true},
  "duotone-black-white": {"name":"Black on white","family":"duotone","background":"#ffffff","foreground":"#202020","accent":"#202020","muted":"#202020","surface":"#20202014","theme":"stone","colors":["#ffffff","#ffffff","#ffffff","#ffffff"],"pattern":0,"lightInk":false},
  "duotone-white-black": {"name":"White on black","family":"duotone","background":"#202020","foreground":"#ffffff","accent":"#ffffff","muted":"#ffffff","surface":"#ffffff14","theme":"ink","colors":["#202020","#202020","#202020","#202020"],"pattern":0,"lightInk":true},
  "duotone-green-white": {"name":"Green on white","family":"duotone","background":"#ffffff","foreground":"#235a3d","accent":"#235a3d","muted":"#235a3d","surface":"#235a3d14","theme":"stone","colors":["#ffffff","#ffffff","#ffffff","#ffffff"],"pattern":0,"lightInk":false},
  "duotone-white-green": {"name":"White on green","family":"duotone","background":"#235a3d","foreground":"#ffffff","accent":"#ffffff","muted":"#ffffff","surface":"#ffffff14","theme":"ink","colors":["#235a3d","#235a3d","#235a3d","#235a3d"],"pattern":0,"lightInk":true},
  "duotone-red-cream": {"name":"Red on cream","family":"duotone","background":"#fff1d8","foreground":"#a52a30","accent":"#a52a30","muted":"#a52a30","surface":"#a52a3014","theme":"stone","colors":["#fff1d8","#fff1d8","#fff1d8","#fff1d8"],"pattern":0,"lightInk":false},
  "duotone-cream-red": {"name":"Cream on red","family":"duotone","background":"#a52a30","foreground":"#fff1d8","accent":"#fff1d8","muted":"#fff1d8","surface":"#fff1d814","theme":"ink","colors":["#a52a30","#a52a30","#a52a30","#a52a30"],"pattern":0,"lightInk":true},
  "duotone-navy-yellow": {"name":"Navy on yellow","family":"duotone","background":"#f4d35e","foreground":"#203653","accent":"#203653","muted":"#203653","surface":"#20365314","theme":"stone","colors":["#f4d35e","#f4d35e","#f4d35e","#f4d35e"],"pattern":0,"lightInk":false},
  "duotone-yellow-navy": {"name":"Yellow on navy","family":"duotone","background":"#203653","foreground":"#f4d35e","accent":"#f4d35e","muted":"#f4d35e","surface":"#f4d35e14","theme":"ink","colors":["#203653","#203653","#203653","#203653"],"pattern":0,"lightInk":true},
  "duotone-cobalt": {"name":"Cobalt on porcelain","family":"duotone","background":"#ffffff","foreground":"#214dcc","accent":"#214dcc","muted":"#214dcc","surface":"#214dcc14","theme":"stone","colors":["#ffffff","#ffffff","#ffffff","#ffffff"],"pattern":0,"lightInk":false},
  "duotone-ink": {"name":"Ink on cream","family":"duotone","background":"#f6efde","foreground":"#192c42","accent":"#192c42","muted":"#192c42","surface":"#192c4214","theme":"stone","colors":["#f6efde","#f6efde","#f6efde","#f6efde"],"pattern":0,"lightInk":false},
  "duotone-forest": {"name":"Forest on mint","family":"duotone","background":"#dcefe2","foreground":"#194c3b","accent":"#194c3b","muted":"#194c3b","surface":"#194c3b14","theme":"stone","colors":["#dcefe2","#dcefe2","#dcefe2","#dcefe2"],"pattern":0,"lightInk":false},
  "duotone-burgundy": {"name":"Burgundy on blush","family":"duotone","background":"#f5dfe3","foreground":"#732a42","accent":"#732a42","muted":"#732a42","surface":"#732a4214","theme":"stone","colors":["#f5dfe3","#f5dfe3","#f5dfe3","#f5dfe3"],"pattern":0,"lightInk":false},
  "duotone-violet": {"name":"Violet on lilac","family":"duotone","background":"#eae0f5","foreground":"#513479","accent":"#513479","muted":"#513479","surface":"#51347914","theme":"stone","colors":["#eae0f5","#eae0f5","#eae0f5","#eae0f5"],"pattern":0,"lightInk":false},
  "duotone-rust": {"name":"Rust on sand","family":"duotone","background":"#f2e4cf","foreground":"#873a26","accent":"#873a26","muted":"#873a26","surface":"#873a2614","theme":"stone","colors":["#f2e4cf","#f2e4cf","#f2e4cf","#f2e4cf"],"pattern":0,"lightInk":false},
  "duotone-electric": {"name":"Ice on cobalt","family":"duotone","background":"#234dc4","foreground":"#eef5ff","accent":"#eef5ff","muted":"#eef5ff","surface":"#eef5ff14","theme":"ink","colors":["#234dc4","#234dc4","#234dc4","#234dc4"],"pattern":0,"lightInk":true},
  "duotone-lime": {"name":"Lime on ink","family":"duotone","background":"#172a32","foreground":"#d9ed9a","accent":"#d9ed9a","muted":"#d9ed9a","surface":"#d9ed9a14","theme":"ink","colors":["#172a32","#172a32","#172a32","#172a32"],"pattern":0,"lightInk":true},
  "white": { "name": "Pure white", "family": "fullcolor", "background": "#ffffff", "foreground": "#173746", "accent": "#173746", "muted": "#536973", "surface": "#17374610", "theme": "stone", "colors": ["#ffffff", "#ffffff", "#ffffff", "#ffffff"], "pattern": 0, "lightInk": false },
  "deepsea": {
    "name": "Deep sea gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#060e1d,#083b49,#125b56,#172540)",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#060e1d",
      "#083b49",
      "#125b56",
      "#172540"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "blackcherry": {
    "name": "Black cherry gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#140b18,#481329,#73243d,#271632)",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#140b18",
      "#481329",
      "#73243d",
      "#271632"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "storm": {
    "name": "Storm gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#0b1220,#243146,#38495b,#161c35)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#0b1220",
      "#243146",
      "#38495b",
      "#161c35"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "indigo": {
    "name": "Indigo gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#0c0a28,#26205a,#393c78,#142741)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#0c0a28",
      "#26205a",
      "#393c78",
      "#142741"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "coppernight": {
    "name": "Copper night gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#160e10,#49281e,#71513a,#251826)",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#160e10",
      "#49281e",
      "#71513a",
      "#251826"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "darkmoss": {
    "name": "Dark moss gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#091916,#1d342c,#3b4b33,#10272d)",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#091916",
      "#1d342c",
      "#3b4b33",
      "#10272d"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "graphite": {
    "name": "Graphite full color",
    "family": "fullcolor",
    "background": "#222630",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#222630",
      "#222630",
      "#222630",
      "#222630"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "aubergine": {
    "name": "Aubergine full color",
    "family": "fullcolor",
    "background": "#2f193b",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#2f193b",
      "#2f193b",
      "#2f193b",
      "#2f193b"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "espresso": {
    "name": "Espresso full color",
    "family": "fullcolor",
    "background": "#35231e",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#35231e",
      "#35231e",
      "#35231e",
      "#35231e"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "darkpetrol": {
    "name": "Dark petrol full color",
    "family": "fullcolor",
    "background": "#12313d",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#12313d",
      "#12313d",
      "#12313d",
      "#12313d"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "moonrise": {
    "name": "Moonrise",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#101528,#546984,#a18492,#384365)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#101528",
      "#546984",
      "#a18492",
      "#384365"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "blackopal": {
    "name": "Black opal",
    "family": "liquid",
    "background": "linear-gradient(135deg,#101325,#233f52,#426761,#60416c)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#101325",
      "#233f52",
      "#426761",
      "#60416c"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "duskweave": {
    "name": "Dusk weave",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#161421,#443046,#795163,#293248)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#161421",
      "#443046",
      "#795163",
      "#293248"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "deepcurrent": {
    "name": "Deep current",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#0c1c26,#205050,#627d7d,#293d66)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#0c1c26",
      "#205050",
      "#627d7d",
      "#293d66"
    ],
    "pattern": 3,
    "lightInk": true
  },
  "abyss": {
    "name": "Abyss gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#050c20,#10234b,#124151,#211538)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#050c20",
      "#10234b",
      "#124151",
      "#211538"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "nocturne": {
    "name": "Nocturne gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#100a20,#342043,#581c3a,#161329)",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#100a20",
      "#342043",
      "#581c3a",
      "#161329"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "embers": {
    "name": "Embers gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#160e12,#542019,#773b25,#25141e)",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#160e12",
      "#542019",
      "#773b25",
      "#25141e"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "obsidian": {
    "name": "Obsidian full color",
    "family": "fullcolor",
    "background": "#101218",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#101218",
      "#101218",
      "#101218",
      "#101218"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "oxblood": {
    "name": "Oxblood full color",
    "family": "fullcolor",
    "background": "#431725",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#431725",
      "#431725",
      "#431725",
      "#431725"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "pine": {
    "name": "Pine full color",
    "family": "fullcolor",
    "background": "#102f2b",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#102f2b",
      "#102f2b",
      "#102f2b",
      "#102f2b"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "eclipse": {
    "name": "Eclipse",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#0b1022,#365675,#a44f77,#314164)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#0b1022",
      "#365675",
      "#a44f77",
      "#314164"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "velvet": {
    "name": "Velvet",
    "family": "liquid",
    "background": "linear-gradient(135deg,#180e27,#402152,#633149,#393363)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#180e27",
      "#402152",
      "#633149",
      "#393363"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "nightfall": {
    "name": "Nightfall",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#101621,#23423e,#465a77,#33283c)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#101621",
      "#23423e",
      "#465a77",
      "#33283c"
    ],
    "pattern": 3,
    "lightInk": true
  },
  "crystal": {
    "name": "Crystal living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#dff5ef99,#dff5efe8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#dff5ef"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#ffffff"
  },
  "ice": {
    "name": "Ice living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#a4dcf699,#a4dcf6e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d8efff",
    "accent": "#d8efff",
    "muted": "#d8efff",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#a4dcf6"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#bdeaff"
  },
  "lagoon": {
    "name": "Lagoon living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#24c8d299,#24c8d2e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#c9f4ed",
    "accent": "#c9f4ed",
    "muted": "#c9f4ed",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#24c8d2"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#46d7d8"
  },
  "mint": {
    "name": "Mint living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#74e7ba99,#74e7bae8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#ddf7df",
    "accent": "#ddf7df",
    "muted": "#ddf7df",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#74e7ba"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#a1f3c6"
  },
  "jade": {
    "name": "Jade living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#36b88d99,#36b88de8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d9f3cc",
    "accent": "#d9f3cc",
    "muted": "#d9f3cc",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#36b88d"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#56d4a6"
  },
  "forest": {
    "name": "Forest living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#1a806e99,#1a806ee8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#1a806e"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#47b299"
  },
  "blue": {
    "name": "Blue living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#49acf099,#49acf0e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d8efff",
    "accent": "#d8efff",
    "muted": "#d8efff",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#49acf0"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#73c4ff"
  },
  "cobalt": {
    "name": "Cobalt living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#3269e499,#3269e4e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#3269e4"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#6c9cfa"
  },
  "ink": {
    "name": "Ink living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#38558199,#385581e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#d8e5fa",
    "accent": "#d8e5fa",
    "muted": "#d8e5fa",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#385581"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#7898c8"
  },
  "rose": {
    "name": "Rose living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#f681a699,#f681a6e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#ffe0ec",
    "accent": "#ffe0ec",
    "muted": "#ffe0ec",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#f681a6"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#ff9dba"
  },
  "blush": {
    "name": "Blush living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#f8bcc899,#f8bcc8e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#ffe5df",
    "accent": "#ffe5df",
    "muted": "#ffe5df",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#f8bcc8"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#ffccd5"
  },
  "cherry": {
    "name": "Cherry living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#d94d7699,#d94d76e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#ffe6d0",
    "accent": "#ffe6d0",
    "muted": "#ffe6d0",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#d94d76"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#f87b9c"
  },
  "pearl": {
    "name": "Pearl living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#eee5e399,#eee5e3e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#f4e9d6",
    "accent": "#f4e9d6",
    "muted": "#f4e9d6",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#eee5e3"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#fff2ed"
  },
  "smoke": {
    "name": "Smoke living glass",
    "family": "livingglass",
    "background": "linear-gradient(135deg,#889aa899,#889aa8e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#dde8f0",
    "accent": "#dde8f0",
    "muted": "#dde8f0",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#889aa8"
    ],
    "pattern": 0,
    "lightInk": true,
    "absorption": "#b6c8d5"
  },
  "aurora": {
    "name": "Aurora gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#83aaff,#44dce5,#c5ffe6,#91aaff)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#83aaff",
      "#44dce5",
      "#c5ffe6",
      "#91aaff"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "bloom": {
    "name": "Bloom gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#ff73af,#ffd5e4,#ffe8c8,#f483d1)",
    "foreground": "#532642",
    "accent": "#532642",
    "muted": "#532642",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#ff73af",
      "#ffd5e4",
      "#ffe8c8",
      "#f483d1"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "tidal": {
    "name": "Tidal gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#03445b,#047889,#2e755c,#193e93)",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#03445b",
      "#047889",
      "#2e755c",
      "#193e93"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "afterglow": {
    "name": "Afterglow gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#241a61,#ab297f,#a64c58,#5552de)",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#241a61",
      "#ab297f",
      "#a64c58",
      "#5552de"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "sorbet": {
    "name": "Sorbet gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#ffeaa3,#ff9cbd,#bcebe0,#f8d0ff)",
    "foreground": "#532642",
    "accent": "#532642",
    "muted": "#532642",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#ffeaa3",
      "#ff9cbd",
      "#bcebe0",
      "#f8d0ff"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "ultrablue": {
    "name": "Ultrablue gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#09147a,#1f51f4,#2f6c91,#4b28af)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#09147a",
      "#1f51f4",
      "#2f6c91",
      "#4b28af"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "midnight": {
    "name": "Midnight full color",
    "family": "fullcolor",
    "background": "#12213f",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#12213f",
      "#12213f",
      "#12213f",
      "#12213f"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "electric": {
    "name": "Electric full color",
    "family": "fullcolor",
    "background": "#1654ee",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#1654ee",
      "#1654ee",
      "#1654ee",
      "#1654ee"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "scarlet": {
    "name": "Scarlet full color",
    "family": "fullcolor",
    "background": "#d92d58",
    "foreground": "#fffdf1",
    "accent": "#fffdf1",
    "muted": "#fffdf1",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#d92d58",
      "#d92d58",
      "#d92d58",
      "#d92d58"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "azalea": {
    "name": "Azalea full color",
    "family": "fullcolor",
    "background": "#ef70aa",
    "foreground": "#4e233e",
    "accent": "#4e233e",
    "muted": "#4e233e",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#ef70aa",
      "#ef70aa",
      "#ef70aa",
      "#ef70aa"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "evergreen": {
    "name": "Evergreen full color",
    "family": "fullcolor",
    "background": "#076b59",
    "foreground": "#d9ffec",
    "accent": "#d9ffec",
    "muted": "#d9ffec",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#076b59",
      "#076b59",
      "#076b59",
      "#076b59"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "pistachio": {
    "name": "Pistachio full color",
    "family": "fullcolor",
    "background": "#cde790",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#cde790",
      "#cde790",
      "#cde790",
      "#cde790"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "porcelain": {
    "name": "Porcelain full color",
    "family": "fullcolor",
    "background": "#f5ecdf",
    "foreground": "#532642",
    "accent": "#532642",
    "muted": "#532642",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f5ecdf",
      "#f5ecdf",
      "#f5ecdf",
      "#f5ecdf"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "sky": {
    "name": "Sky full color",
    "family": "fullcolor",
    "background": "#74cff0",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#74cff0",
      "#74cff0",
      "#74cff0",
      "#74cff0"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "orbit": {
    "name": "Orbit",
    "family": "snazzy",
    "background": "radial-gradient(circle at 80% 60%,#ff638e 0 18%,transparent 19%),repeating-radial-gradient(ellipse at 85% 10%,#51ead0 0 3px,#102345 4px 10px)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#102345",
      "#51ead0",
      "#ff638e",
      "#5f80ff"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "prism": {
    "name": "Prism",
    "family": "snazzy",
    "background": "repeating-linear-gradient(125deg,#d4f4dc 0 12px,#4779ff 12px 24px,#ff72a9 24px 36px,#c4b2ff 36px 48px)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#d4f4dc",
      "#4779ff",
      "#ff72a9",
      "#c4b2ff"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "liquid": {
    "name": "Liquid",
    "family": "liquid",
    "background": "radial-gradient(ellipse at 70% 20%,#f88bbe,transparent 65%),linear-gradient(145deg,#102a78,#0069f2,#59eed8)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#102a78",
      "#0069f2",
      "#59eed8",
      "#f88bbe"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "ripple": {
    "name": "Ripple",
    "family": "snazzy",
    "background": "repeating-radial-gradient(ellipse at 100% 100%,#34124f 0 5px,#dd397e 5px 9px,#ff9988 9px 12px,#7470ff 12px 16px)",
    "foreground": "#e2edff",
    "accent": "#e2edff",
    "muted": "#e2edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#34124f",
      "#dd397e",
      "#ff9988",
      "#7470ff"
    ],
    "pattern": 3,
    "lightInk": true
  },
  "confetti": {
    "name": "Confetti",
    "family": "snazzy",
    "background": "repeating-conic-gradient(from 30deg at 65% 50%,#ff577e 0 16deg,transparent 16deg 80deg,#0f9d94 80deg 100deg,transparent 100deg 150deg),#f6ebd3",
    "foreground": "#532642",
    "accent": "#532642",
    "muted": "#532642",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f6ebd3",
      "#0f9d94",
      "#ff577e",
      "#4875ed"
    ],
    "pattern": 4,
    "lightInk": false
  },
  "checker": {
    "name": "Playtime",
    "family": "snazzy",
    "background": "repeating-conic-gradient(#ffd4df 0% 25%,#ec3e7b 0% 50%) 0 0 / 18px 18px",
    "foreground": "#532642",
    "accent": "#532642",
    "muted": "#532642",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#ffd4df",
      "#ec3e7b",
      "#62c9d6",
      "#ffc780"
    ],
    "pattern": 5,
    "lightInk": false
  },
  "sunbeam": {
    "name": "Sunbeam gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#ffe477,#ffd338,#ffba52,#fff1a2)",
    "foreground": "#563309",
    "accent": "#563309",
    "muted": "#563309",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ffe477",
      "#ffd338",
      "#ffba52",
      "#fff1a2"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "vermillion": {
    "name": "Vermillion gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#ff8064,#ffab64,#ffcb88,#ff8967)",
    "foreground": "#582415",
    "accent": "#582415",
    "muted": "#582415",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ff8064",
      "#ffab64",
      "#ffcb88",
      "#ff8967"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "bluebird": {
    "name": "Bluebird gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#68b8ff,#90dcff,#b7e9ff,#81a9f5)",
    "foreground": "#123966",
    "accent": "#123966",
    "muted": "#123966",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#68b8ff",
      "#90dcff",
      "#b7e9ff",
      "#81a9f5"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "citrus": {
    "name": "Citrus gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#d2ee58,#f4ed77,#a9e19a,#efffb4)",
    "foreground": "#284713",
    "accent": "#284713",
    "muted": "#284713",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#d2ee58",
      "#f4ed77",
      "#a9e19a",
      "#efffb4"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "royal": {
    "name": "Royal gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#263dad,#314ac4,#344eb7,#223c95)",
    "foreground": "#e5ecff",
    "accent": "#e5ecff",
    "muted": "#e5ecff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#263dad",
      "#314ac4",
      "#344eb7",
      "#223c95"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "apricot": {
    "name": "Apricot full color",
    "family": "fullcolor",
    "background": "#ffdaa9",
    "foreground": "#603715",
    "accent": "#603715",
    "muted": "#603715",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ffdaa9"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "butter": {
    "name": "Butter full color",
    "family": "fullcolor",
    "background": "#fff0a8",
    "foreground": "#554216",
    "accent": "#554216",
    "muted": "#554216",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#fff0a8"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "powder": {
    "name": "Powder blue full color",
    "family": "fullcolor",
    "background": "#c9e6ff",
    "foreground": "#204b72",
    "accent": "#204b72",
    "muted": "#204b72",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#c9e6ff"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "seafoam": {
    "name": "Seafoam full color",
    "family": "fullcolor",
    "background": "#c1f0db",
    "foreground": "#215641",
    "accent": "#215641",
    "muted": "#215641",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#c1f0db"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "lilac": {
    "name": "Lilac full color",
    "family": "fullcolor",
    "background": "#e0d6fa",
    "foreground": "#51376c",
    "accent": "#51376c",
    "muted": "#51376c",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#e0d6fa"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "oat": {
    "name": "Oat full color",
    "family": "fullcolor",
    "background": "#eae1cc",
    "foreground": "#55452c",
    "accent": "#55452c",
    "muted": "#55452c",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#eae1cc"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "terraces": {
    "name": "Terraces",
    "family": "snazzy",
    "background": "repeating-linear-gradient(0deg,#f8df86 0 16px,#e49b0a 16px 20px,#368344 20px 24px)",
    "foreground": "#4b3a12",
    "accent": "#4b3a12",
    "muted": "#4b3a12",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#f8df86",
      "#e49b0a",
      "#368344",
      "#f5cc5f"
    ],
    "pattern": 6,
    "lightInk": false
  },
  "sundial": {
    "name": "Sundial",
    "family": "snazzy",
    "background": "repeating-conic-gradient(from 20deg at 85% 50%,#ffeab0 0deg 20deg,#ec8e16 20deg 40deg)",
    "foreground": "#623411",
    "accent": "#623411",
    "muted": "#623411",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ffeab0",
      "#ec8e16",
      "#ca610e",
      "#ffc64d"
    ],
    "pattern": 7,
    "lightInk": false
  },
  "mosaic": {
    "name": "Mosaic",
    "family": "snazzy",
    "background": "repeating-conic-gradient(#bfeaf5 0% 25%,#218cae 0% 50%) 0 0 / 32px 32px",
    "foreground": "#174953",
    "accent": "#174953",
    "muted": "#174953",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#bfeaf5",
      "#218cae",
      "#299774",
      "#d9ed81"
    ],
    "pattern": 8,
    "lightInk": false
  },
  "ribbons": {
    "name": "Ribbons",
    "family": "snazzy",
    "background": "repeating-linear-gradient(125deg,#e4ed9c 0 12px,#438e37 12px 20px,#9ebf29 20px 30px)",
    "foreground": "#304b17",
    "accent": "#304b17",
    "muted": "#304b17",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#e4ed9c",
      "#9ebf29",
      "#438e37",
      "#d4ed80"
    ],
    "pattern": 9,
    "lightInk": false
  },
  "lagoonflow": {
    "name": "Lagoon flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#b4f1df,#69d7d2,#8bcaed,#d5f5ba)",
    "foreground": "#174d4e",
    "accent": "#174d4e",
    "muted": "#174d4e",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#b4f1df",
      "#69d7d2",
      "#8bcaed",
      "#d5f5ba"
    ],
    "pattern": 2,
    "lightInk": false
  },
  "honeyflow": {
    "name": "Honey flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#ffe7a0,#edbd57,#ffda83,#f8eecc)",
    "foreground": "#603c11",
    "accent": "#603c11",
    "muted": "#603c11",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ffe7a0",
      "#edbd57",
      "#ffda83",
      "#f8eecc"
    ],
    "pattern": 2,
    "lightInk": false
  },
  "cobaltflow": {
    "name": "Cobalt flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#162e85,#264bb1,#276c9f,#18475e)",
    "foreground": "#def4ff",
    "accent": "#def4ff",
    "muted": "#def4ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#162e85",
      "#264bb1",
      "#276c9f",
      "#18475e"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "jadeflow": {
    "name": "Jade flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#164c40,#226f50,#286666,#284c58)",
    "foreground": "#d8ffe5",
    "accent": "#d8ffe5",
    "muted": "#d8ffe5",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#164c40",
      "#226f50",
      "#286666",
      "#284c58"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "amberflow": {
    "name": "Amber flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#65301b,#84451f,#956123,#693723)",
    "foreground": "#fff0c8",
    "accent": "#fff0c8",
    "muted": "#fff0c8",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#65301b",
      "#84451f",
      "#956123",
      "#693723"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "aquamarble": {
    "name": "Aqua marble",
    "family": "liquid",
    "background": "linear-gradient(135deg,#a1efdf,#37aebe,#70c9c0,#d3f69e)",
    "foreground": "#103f45",
    "accent": "#103f45",
    "muted": "#103f45",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#a1efdf",
      "#37aebe",
      "#70c9c0",
      "#d3f69e"
    ],
    "pattern": 10,
    "lightInk": false
  },
  "lapismarble": {
    "name": "Lapis marble",
    "family": "liquid",
    "background": "linear-gradient(135deg,#152d78,#295db0,#367590,#394481)",
    "foreground": "#e1f1ff",
    "accent": "#e1f1ff",
    "muted": "#e1f1ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#152d78",
      "#295db0",
      "#367590",
      "#394481"
    ],
    "pattern": 10,
    "lightInk": true
  },
  "ambermarble": {
    "name": "Amber marble",
    "family": "liquid",
    "background": "linear-gradient(135deg,#f9d78c,#d69630,#f1b851,#f7e9b4)",
    "foreground": "#58360d",
    "accent": "#58360d",
    "muted": "#58360d",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#f9d78c",
      "#d69630",
      "#f1b851",
      "#f7e9b4"
    ],
    "pattern": 10,
    "lightInk": false
  },
  "emeraldmarble": {
    "name": "Emerald marble",
    "family": "liquid",
    "background": "linear-gradient(135deg,#164c3b,#2e7c55,#527749,#225f62)",
    "foreground": "#d9ffe6",
    "accent": "#d9ffe6",
    "muted": "#d9ffe6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#164c3b",
      "#2e7c55",
      "#527749",
      "#225f62"
    ],
    "pattern": 10,
    "lightInk": true
  },
  "citrussilk": {
    "name": "Citrus silk",
    "family": "liquid",
    "background": "linear-gradient(135deg,#e4ed9c,#a1c34b,#d7ce46,#f9f1a6)",
    "foreground": "#344515",
    "accent": "#344515",
    "muted": "#344515",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#e4ed9c",
      "#a1c34b",
      "#d7ce46",
      "#f9f1a6"
    ],
    "pattern": 11,
    "lightInk": false
  },
  "azuresilk": {
    "name": "Azure silk",
    "family": "liquid",
    "background": "linear-gradient(135deg,#a5dbf2,#59a5d3,#699be1,#d8f0ec)",
    "foreground": "#173f65",
    "accent": "#173f65",
    "muted": "#173f65",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#a5dbf2",
      "#59a5d3",
      "#699be1",
      "#d8f0ec"
    ],
    "pattern": 11,
    "lightInk": false
  },
  "violetsilk": {
    "name": "Violet silk",
    "family": "liquid",
    "background": "linear-gradient(135deg,#302160,#593e86,#4e5595,#633974)",
    "foreground": "#eee4ff",
    "accent": "#eee4ff",
    "muted": "#eee4ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#302160",
      "#593e86",
      "#4e5595",
      "#633974"
    ],
    "pattern": 11,
    "lightInk": true
  },
  "coppersilk": {
    "name": "Copper silk",
    "family": "liquid",
    "background": "linear-gradient(135deg,#683322,#934f2c,#98723d,#7b4738)",
    "foreground": "#fff0d9",
    "accent": "#fff0d9",
    "muted": "#fff0d9",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#683322",
      "#934f2c",
      "#98723d",
      "#7b4738"
    ],
    "pattern": 11,
    "lightInk": true
  },
  "oceaneddy": {
    "name": "Ocean eddy",
    "family": "liquid",
    "background": "linear-gradient(135deg,#133e60,#167c89,#346496,#15584f)",
    "foreground": "#dbf7ff",
    "accent": "#dbf7ff",
    "muted": "#dbf7ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#133e60",
      "#167c89",
      "#346496",
      "#15584f"
    ],
    "pattern": 12,
    "lightInk": true
  },
  "lemoneddy": {
    "name": "Lemon eddy",
    "family": "liquid",
    "background": "linear-gradient(135deg,#f5eaa7,#c6bf51,#e6bb53,#faf2cc)",
    "foreground": "#514413",
    "accent": "#514413",
    "muted": "#514413",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#f5eaa7",
      "#c6bf51",
      "#e6bb53",
      "#faf2cc"
    ],
    "pattern": 12,
    "lightInk": false
  },
  "ferneddy": {
    "name": "Fern eddy",
    "family": "liquid",
    "background": "linear-gradient(135deg,#c3e6ba,#76b184,#95c36c,#dded9c)",
    "foreground": "#254c2d",
    "accent": "#254c2d",
    "muted": "#254c2d",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#c3e6ba",
      "#76b184",
      "#95c36c",
      "#dded9c"
    ],
    "pattern": 12,
    "lightInk": false
  },
  "bronzeeddy": {
    "name": "Bronze eddy",
    "family": "liquid",
    "background": "linear-gradient(135deg,#513925,#89642e,#736840,#644838)",
    "foreground": "#fff0d1",
    "accent": "#fff0d1",
    "muted": "#fff0d1",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#513925",
      "#89642e",
      "#736840",
      "#644838"
    ],
    "pattern": 12,
    "lightInk": true
  },
  "trueblue": {
    "name": "True blue gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#153bb3,#2154cd,#315bac,#173a91)",
    "foreground": "#e9f1ff",
    "accent": "#e9f1ff",
    "muted": "#e9f1ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#153bb3",
      "#2154cd",
      "#315bac",
      "#173a91"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "redochre": {
    "name": "Red ochre gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#8a271c,#b63822,#a6311a,#782a25)",
    "foreground": "#fff1d8",
    "accent": "#fff1d8",
    "muted": "#fff1d8",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#8a271c",
      "#b63822",
      "#a6311a",
      "#782a25"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "goldenhour": {
    "name": "Golden hour gradient",
    "family": "gradient",
    "background": "linear-gradient(135deg,#ffd23c,#f5c557,#ffe48a,#f4d14d)",
    "foreground": "#573c0c",
    "accent": "#573c0c",
    "muted": "#573c0c",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#ffd23c",
      "#f5c557",
      "#ffe48a",
      "#f4d14d"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "celadon": {
    "name": "Celadon full color",
    "family": "fullcolor",
    "background": "#dbe8c0",
    "foreground": "#3a5125",
    "accent": "#3a5125",
    "muted": "#3a5125",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#dbe8c0"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "periwinkle": {
    "name": "Periwinkle full color",
    "family": "fullcolor",
    "background": "#cdd5f8",
    "foreground": "#354570",
    "accent": "#354570",
    "muted": "#354570",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#cdd5f8"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "sandstone": {
    "name": "Sandstone full color",
    "family": "fullcolor",
    "background": "#efd3b7",
    "foreground": "#63432a",
    "accent": "#63432a",
    "muted": "#63432a",
    "surface": "#ffffff26",
    "theme": "stone",
    "colors": [
      "#efd3b7"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "clearcrystal": {
    "name": "Crystal glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#dff5ef99,#dff5efe8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#dff5ef"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#ffffff"
  },
  "clearice": {
    "name": "Ice glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#a4dcf699,#a4dcf6e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#a4dcf6"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#bdeaff"
  },
  "clearlagoon": {
    "name": "Lagoon glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#24c8d299,#24c8d2e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#24c8d2"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#46d7d8"
  },
  "clearmint": {
    "name": "Mint glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#74e7ba99,#74e7bae8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#74e7ba"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#a1f3c6"
  },
  "clearjade": {
    "name": "Jade glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#36b88d99,#36b88de8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#36b88d"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#56d4a6"
  },
  "clearforest": {
    "name": "Forest glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#1a806e99,#1a806ee8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#1a806e"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#47b299"
  },
  "clearblue": {
    "name": "Blue glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#49acf099,#49acf0e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#49acf0"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#73c4ff"
  },
  "clearcobalt": {
    "name": "Cobalt glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#3269e499,#3269e4e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#3269e4"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#6c9cfa"
  },
  "clearink": {
    "name": "Ink glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#38558199,#385581e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#385581"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#7898c8"
  },
  "clearrose": {
    "name": "Rose glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#f681a699,#f681a6e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#f681a6"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#ff9dba"
  },
  "clearblush": {
    "name": "Blush glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#f8bcc899,#f8bcc8e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#f8bcc8"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#ffccd5"
  },
  "clearcherry": {
    "name": "Cherry glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#d94d7699,#d94d76e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#d94d76"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#f87b9c"
  },
  "clearpearl": {
    "name": "Pearl glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#eee5e399,#eee5e3e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#eee5e3"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#fff2ed"
  },
  "clearsmoke": {
    "name": "Smoke glass",
    "family": "glass",
    "background": "linear-gradient(135deg,#889aa899,#889aa8e8),radial-gradient(ellipse at 80% 0%,#fbb2ca,#7cdae1 60%)",
    "foreground": "#103c57",
    "accent": "#103c57",
    "muted": "#103c57",
    "surface": "#ffffff45",
    "theme": "cobalt",
    "colors": [
      "#889aa8"
    ],
    "pattern": 0,
    "lightInk": false,
    "absorption": "#b6c8d5"
  },
  "solidporcelain": {
    "name": "Chalk full color",
    "family": "fullcolor",
    "background": "#f5f1e8",
    "foreground": "#514833",
    "accent": "#514833",
    "muted": "#514833",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f5f1e8"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidoat": {
    "name": "Wheat full color",
    "family": "fullcolor",
    "background": "#dfd1b6",
    "foreground": "#51402c",
    "accent": "#51402c",
    "muted": "#51402c",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#dfd1b6"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidbuttermilk": {
    "name": "Buttermilk full color",
    "family": "fullcolor",
    "background": "#f5e7aa",
    "foreground": "#5a4717",
    "accent": "#5a4717",
    "muted": "#5a4717",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f5e7aa"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidmarigold": {
    "name": "Marigold full color",
    "family": "fullcolor",
    "background": "#edba45",
    "foreground": "#4d3511",
    "accent": "#4d3511",
    "muted": "#4d3511",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#edba45"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidapricot": {
    "name": "Nectarine full color",
    "family": "fullcolor",
    "background": "#f3b78c",
    "foreground": "#643820",
    "accent": "#643820",
    "muted": "#643820",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f3b78c"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidterracotta": {
    "name": "Terracotta full color",
    "family": "fullcolor",
    "background": "#b35e45",
    "foreground": "#fff0d6",
    "accent": "#fff0d6",
    "muted": "#fff0d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#b35e45"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidpapaya": {
    "name": "Papaya full color",
    "family": "fullcolor",
    "background": "#f38862",
    "foreground": "#592b23",
    "accent": "#592b23",
    "muted": "#592b23",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f38862"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidpetal": {
    "name": "Petal full color",
    "family": "fullcolor",
    "background": "#f0ccd9",
    "foreground": "#613449",
    "accent": "#613449",
    "muted": "#613449",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f0ccd9"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidraspberry": {
    "name": "Raspberry full color",
    "family": "fullcolor",
    "background": "#8b315a",
    "foreground": "#ffe1ed",
    "accent": "#ffe1ed",
    "muted": "#ffe1ed",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#8b315a"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidmulberry": {
    "name": "Mulberry full color",
    "family": "fullcolor",
    "background": "#542b4b",
    "foreground": "#f5d9ed",
    "accent": "#f5d9ed",
    "muted": "#f5d9ed",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#542b4b"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidwisteria": {
    "name": "Wisteria full color",
    "family": "fullcolor",
    "background": "#c6b6e7",
    "foreground": "#47345f",
    "accent": "#47345f",
    "muted": "#47345f",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#c6b6e7"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidiris": {
    "name": "Iris full color",
    "family": "fullcolor",
    "background": "#66519b",
    "foreground": "#eee3ff",
    "accent": "#eee3ff",
    "muted": "#eee3ff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#66519b"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidpowder": {
    "name": "Glacier full color",
    "family": "fullcolor",
    "background": "#b7d9ed",
    "foreground": "#234c63",
    "accent": "#234c63",
    "muted": "#234c63",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#b7d9ed"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "soliddenim": {
    "name": "Denim full color",
    "family": "fullcolor",
    "background": "#315579",
    "foreground": "#dbeeff",
    "accent": "#dbeeff",
    "muted": "#dbeeff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#315579"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidpetrol": {
    "name": "Petrol full color",
    "family": "fullcolor",
    "background": "#244e58",
    "foreground": "#d3f3ed",
    "accent": "#d3f3ed",
    "muted": "#d3f3ed",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#244e58"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solideucalyptus": {
    "name": "Eucalyptus full color",
    "family": "fullcolor",
    "background": "#a6c6ad",
    "foreground": "#284c3b",
    "accent": "#284c3b",
    "muted": "#284c3b",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#a6c6ad"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidmoss": {
    "name": "Moss full color",
    "family": "fullcolor",
    "background": "#536b42",
    "foreground": "#e9f1d6",
    "accent": "#e9f1d6",
    "muted": "#e9f1d6",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#536b42"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidolive": {
    "name": "Olive full color",
    "family": "fullcolor",
    "background": "#929562",
    "foreground": "#303c21",
    "accent": "#303c21",
    "muted": "#303c21",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#929562"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "solidespresso": {
    "name": "Coffee full color",
    "family": "fullcolor",
    "background": "#382b28",
    "foreground": "#f0dfcc",
    "accent": "#f0dfcc",
    "muted": "#f0dfcc",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#382b28"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "solidgraphite": {
    "name": "Charcoal full color",
    "family": "fullcolor",
    "background": "#343b43",
    "foreground": "#dfe8f0",
    "accent": "#dfe8f0",
    "muted": "#dfe8f0",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#343b43"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "playcitrus": {
    "name": "Citrus play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#f7e8b1,#d8792f,#748653,#f2bd51)",
    "foreground": "#533c19",
    "accent": "#533c19",
    "muted": "#533c19",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f7e8b1",
      "#d8792f",
      "#748653",
      "#f2bd51"
    ],
    "pattern": 0,
    "lightInk": false
  },
  "flowcitrus": {
    "name": "Citrus flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#f7e8b1,#d8792f,#748653,#f2bd51)",
    "foreground": "#533c19",
    "accent": "#533c19",
    "muted": "#533c19",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f7e8b1",
      "#d8792f",
      "#748653",
      "#f2bd51"
    ],
    "pattern": 2,
    "lightInk": false
  },
  "playorchid": {
    "name": "Orchid play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#edd5ee,#a56ab7,#d878a7,#bcabe3)",
    "foreground": "#533459",
    "accent": "#533459",
    "muted": "#533459",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#edd5ee",
      "#a56ab7",
      "#d878a7",
      "#bcabe3"
    ],
    "pattern": 1,
    "lightInk": false
  },
  "floworchid": {
    "name": "Orchid flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#edd5ee,#a56ab7,#d878a7,#bcabe3)",
    "foreground": "#533459",
    "accent": "#533459",
    "muted": "#533459",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#edd5ee",
      "#a56ab7",
      "#d878a7",
      "#bcabe3"
    ],
    "pattern": 3,
    "lightInk": false
  },
  "playriviera": {
    "name": "Riviera play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#cce9ee,#26778e,#ea9a6b,#f4deac)",
    "foreground": "#244a5b",
    "accent": "#244a5b",
    "muted": "#244a5b",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#cce9ee",
      "#26778e",
      "#ea9a6b",
      "#f4deac"
    ],
    "pattern": 4,
    "lightInk": false
  },
  "flowriviera": {
    "name": "Riviera flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#cce9ee,#26778e,#ea9a6b,#f4deac)",
    "foreground": "#244a5b",
    "accent": "#244a5b",
    "muted": "#244a5b",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#cce9ee",
      "#26778e",
      "#ea9a6b",
      "#f4deac"
    ],
    "pattern": 10,
    "lightInk": false
  },
  "playcherrycream": {
    "name": "Cherry cream play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#f8e0d3,#b44160,#df879a,#ecc8ad)",
    "foreground": "#653448",
    "accent": "#653448",
    "muted": "#653448",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f8e0d3",
      "#b44160",
      "#df879a",
      "#ecc8ad"
    ],
    "pattern": 5,
    "lightInk": false
  },
  "flowcherrycream": {
    "name": "Cherry cream flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#f8e0d3,#b44160,#df879a,#ecc8ad)",
    "foreground": "#653448",
    "accent": "#653448",
    "muted": "#653448",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#f8e0d3",
      "#b44160",
      "#df879a",
      "#ecc8ad"
    ],
    "pattern": 11,
    "lightInk": false
  },
  "playfern": {
    "name": "Fern play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#d9e6be,#577b52,#92af6b,#eddfa2)",
    "foreground": "#314b29",
    "accent": "#314b29",
    "muted": "#314b29",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#d9e6be",
      "#577b52",
      "#92af6b",
      "#eddfa2"
    ],
    "pattern": 6,
    "lightInk": false
  },
  "flowfern": {
    "name": "Fern flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#d9e6be,#577b52,#92af6b,#eddfa2)",
    "foreground": "#314b29",
    "accent": "#314b29",
    "muted": "#314b29",
    "surface": "#ffffff45",
    "theme": "stone",
    "colors": [
      "#d9e6be",
      "#577b52",
      "#92af6b",
      "#eddfa2"
    ],
    "pattern": 12,
    "lightInk": false
  },
  "playnightbloom": {
    "name": "Night bloom play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#292439,#665080,#a9638d,#9b8bab)",
    "foreground": "#f0dfee",
    "accent": "#f0dfee",
    "muted": "#f0dfee",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#292439",
      "#665080",
      "#a9638d",
      "#9b8bab"
    ],
    "pattern": 7,
    "lightInk": true
  },
  "flownightbloom": {
    "name": "Night bloom flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#292439,#665080,#a9638d,#9b8bab)",
    "foreground": "#f0dfee",
    "accent": "#f0dfee",
    "muted": "#f0dfee",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#292439",
      "#665080",
      "#a9638d",
      "#9b8bab"
    ],
    "pattern": 2,
    "lightInk": true
  },
  "playcopper": {
    "name": "Copper play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#422b29,#976047,#c68b65,#675355)",
    "foreground": "#f8e4cc",
    "accent": "#f8e4cc",
    "muted": "#f8e4cc",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#422b29",
      "#976047",
      "#c68b65",
      "#675355"
    ],
    "pattern": 8,
    "lightInk": true
  },
  "flowcopper": {
    "name": "Copper flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#422b29,#976047,#c68b65,#675355)",
    "foreground": "#f8e4cc",
    "accent": "#f8e4cc",
    "muted": "#f8e4cc",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#422b29",
      "#976047",
      "#c68b65",
      "#675355"
    ],
    "pattern": 3,
    "lightInk": true
  },
  "playdeepcurrent": {
    "name": "Deep current play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#163b48,#276c7a,#579a95,#7799b8)",
    "foreground": "#d5f2f0",
    "accent": "#d5f2f0",
    "muted": "#d5f2f0",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#163b48",
      "#276c7a",
      "#579a95",
      "#7799b8"
    ],
    "pattern": 9,
    "lightInk": true
  },
  "flowdeepcurrent": {
    "name": "Deep current flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#163b48,#276c7a,#579a95,#7799b8)",
    "foreground": "#d5f2f0",
    "accent": "#d5f2f0",
    "muted": "#d5f2f0",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#163b48",
      "#276c7a",
      "#579a95",
      "#7799b8"
    ],
    "pattern": 10,
    "lightInk": true
  },
  "playbluehour": {
    "name": "Blue hour play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#263953,#41659b,#7e7dae,#65a2b9)",
    "foreground": "#e0edff",
    "accent": "#e0edff",
    "muted": "#e0edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#263953",
      "#41659b",
      "#7e7dae",
      "#65a2b9"
    ],
    "pattern": 0,
    "lightInk": true
  },
  "flowbluehour": {
    "name": "Blue hour flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#263953,#41659b,#7e7dae,#65a2b9)",
    "foreground": "#e0edff",
    "accent": "#e0edff",
    "muted": "#e0edff",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#263953",
      "#41659b",
      "#7e7dae",
      "#65a2b9"
    ],
    "pattern": 11,
    "lightInk": true
  },
  "playsaffron": {
    "name": "Saffron play",
    "family": "snazzy",
    "background": "linear-gradient(135deg,#4e3825,#a77938,#ceab65,#80604a)",
    "foreground": "#f8e8c8",
    "accent": "#f8e8c8",
    "muted": "#f8e8c8",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#4e3825",
      "#a77938",
      "#ceab65",
      "#80604a"
    ],
    "pattern": 1,
    "lightInk": true
  },
  "flowsaffron": {
    "name": "Saffron flow",
    "family": "liquid",
    "background": "linear-gradient(135deg,#4e3825,#a77938,#ceab65,#80604a)",
    "foreground": "#f8e8c8",
    "accent": "#f8e8c8",
    "muted": "#f8e8c8",
    "surface": "#ffffff26",
    "theme": "ink",
    "colors": [
      "#4e3825",
      "#a77938",
      "#ceab65",
      "#80604a"
    ],
    "pattern": 12,
    "lightInk": true
  },
  "starlight": { "name": "Starlight", "family": "space", "background": "linear-gradient(135deg,#050719,#101833,#3e2c72,#7892d0)", "foreground": "#eef1ff", "accent": "#eef1ff", "muted": "#dfe7ff", "surface": "#ffffff26", "theme": "ink", "colors": ["#050719", "#101833", "#3e2c72", "#7892d0"], "pattern": 0, "lightInk": true },
  "andromeda": { "name": "Andromeda", "family": "space", "background": "linear-gradient(135deg,#080515,#22153f,#742a62,#bd6b9f)", "foreground": "#fff0fb", "accent": "#fff0fb", "muted": "#f4d7ee", "surface": "#ffffff26", "theme": "ink", "colors": ["#080515", "#22153f", "#742a62", "#bd6b9f"], "pattern": 1, "lightInk": true },
  "orion": { "name": "Orion", "family": "space", "background": "linear-gradient(135deg,#061525,#09334d,#39758f,#8ca08d)", "foreground": "#ecf9ff", "accent": "#ecf9ff", "muted": "#d8eff7", "surface": "#ffffff26", "theme": "ink", "colors": ["#061525", "#09334d", "#39758f", "#8ca08d"], "pattern": 2, "lightInk": true },
  "lunareclipse": { "name": "Lunar eclipse", "family": "space", "background": "linear-gradient(135deg,#03030a,#12172a,#3c4787,#8591cc)", "foreground": "#f2f4ff", "accent": "#f2f4ff", "muted": "#dfe4ff", "surface": "#ffffff26", "theme": "ink", "colors": ["#03030a", "#12172a", "#3c4787", "#8591cc"], "pattern": 3, "lightInk": true },
  "cosmicdust": { "name": "Cosmic dust", "family": "space", "background": "linear-gradient(135deg,#13071f,#401345,#953a63,#c48569)", "foreground": "#fff3fb", "accent": "#fff3fb", "muted": "#f7ddeb", "surface": "#ffffff26", "theme": "ink", "colors": ["#13071f", "#401345", "#953a63", "#c48569"], "pattern": 4, "lightInk": true },
  "nebulacrown": { "name": "Nebula crown", "family": "space", "background": "linear-gradient(135deg,#050b1b,#0f2d4c,#2d6d82,#8cc5b3)", "foreground": "#edfff6", "accent": "#edfff6", "muted": "#d8f1e4", "surface": "#ffffff26", "theme": "ink", "colors": ["#050b1b", "#0f2d4c", "#2d6d82", "#8cc5b3"], "pattern": 5, "lightInk": true },
  "eventide": { "name": "Eventide", "family": "space", "background": "linear-gradient(135deg,#090613,#211036,#4f2b61,#657fb0)", "foreground": "#f2efff", "accent": "#f2efff", "muted": "#e3dcf5", "surface": "#ffffff26", "theme": "ink", "colors": ["#090613", "#211036", "#4f2b61", "#657fb0"], "pattern": 6, "lightInk": true },
  "solarwind": { "name": "Solar wind", "family": "space", "background": "linear-gradient(135deg,#0b0d20,#192b5a,#2f7082,#bc935e)", "foreground": "#f4fbff", "accent": "#f4fbff", "muted": "#dceefa", "surface": "#ffffff26", "theme": "ink", "colors": ["#0b0d20", "#192b5a", "#2f7082", "#bc935e"], "pattern": 7, "lightInk": true },
  "bluedwarf": { "name": "Blue dwarf", "family": "space", "background": "linear-gradient(135deg,#020712,#0b2850,#176ea0,#8acbe0)", "foreground": "#effbff", "accent": "#effbff", "muted": "#d5edf4", "surface": "#ffffff26", "theme": "ink", "colors": ["#020712", "#0b2850", "#176ea0", "#8acbe0"], "pattern": 8, "lightInk": true },
  "horsehead": { "name": "Horsehead", "family": "space", "background": "linear-gradient(135deg,#0e0610,#30132c,#7e3140,#c66d56)", "foreground": "#fff1ed", "accent": "#fff1ed", "muted": "#efd6d0", "surface": "#ffffff26", "theme": "ink", "colors": ["#0e0610", "#30132c", "#7e3140", "#c66d56"], "pattern": 9, "lightInk": true },
  "deepvoid": { "name": "Deep void", "family": "space", "background": "linear-gradient(135deg,#01020a,#0a1030,#243367,#7381b7)", "foreground": "#eef1ff", "accent": "#eef1ff", "muted": "#d9def5", "surface": "#ffffff26", "theme": "ink", "colors": ["#01020a", "#0a1030", "#243367", "#7381b7"], "pattern": 10, "lightInk": true },
  "pulsar": { "name": "Pulsar", "family": "space", "background": "linear-gradient(135deg,#050313,#241044,#573480,#b171bf)", "foreground": "#fbf2ff", "accent": "#fbf2ff", "muted": "#ead9f1", "surface": "#ffffff26", "theme": "ink", "colors": ["#050313", "#241044", "#573480", "#b171bf"], "pattern": 11, "lightInk": true },
  "starlightmidnight": {"name": "Starlight midnight", "family": "space", "background": "linear-gradient(135deg,#010206,#050810,#241a42,#52638d)", "foreground": "#eef1ff", "accent": "#eef1ff", "muted": "#dfe7ff", "surface": "#ffffff26", "theme": "ink", "colors": ["#010206", "#050810", "#241a42", "#52638d"], "pattern": 12, "lightInk": true},
  "andromedamidnight": {"name": "Andromeda midnight", "family": "space", "background": "linear-gradient(135deg,#020105,#0b0714,#431839,#81496c)", "foreground": "#fff0fb", "accent": "#fff0fb", "muted": "#f4d7ee", "surface": "#ffffff26", "theme": "ink", "colors": ["#020105", "#0b0714", "#431839", "#81496c"], "pattern": 13, "lightInk": true},
  "orionmidnight": {"name": "Orion midnight", "family": "space", "background": "linear-gradient(135deg,#010508,#031019,#214453,#5f6d60)", "foreground": "#ecf9ff", "accent": "#ecf9ff", "muted": "#d8eff7", "surface": "#ffffff26", "theme": "ink", "colors": ["#010508", "#031019", "#214453", "#5f6d60"], "pattern": 14, "lightInk": true},
  "lunareclipsemidnight": {"name": "Lunar eclipse midnight", "family": "space", "background": "linear-gradient(135deg,#010102,#06070d,#23294e,#5a638b)", "foreground": "#f2f4ff", "accent": "#f2f4ff", "muted": "#dfe4ff", "surface": "#ffffff26", "theme": "ink", "colors": ["#010102", "#06070d", "#23294e", "#5a638b"], "pattern": 15, "lightInk": true},
  "cosmicdustmidnight": {"name": "Cosmic dust midnight", "family": "space", "background": "linear-gradient(135deg,#040207,#140616,#562239,#855a47)", "foreground": "#fff3fb", "accent": "#fff3fb", "muted": "#f7ddeb", "surface": "#ffffff26", "theme": "ink", "colors": ["#040207", "#140616", "#562239", "#855a47"], "pattern": 16, "lightInk": true},
  "nebulacrownmidnight": {"name": "Nebula crown midnight", "family": "space", "background": "linear-gradient(135deg,#010206,#050e18,#1a3f4b,#5f867a)", "foreground": "#edfff6", "accent": "#edfff6", "muted": "#d8f1e4", "surface": "#ffffff26", "theme": "ink", "colors": ["#010206", "#050e18", "#1a3f4b", "#5f867a"], "pattern": 17, "lightInk": true},
  "eventidemidnight": {"name": "Eventide midnight", "family": "space", "background": "linear-gradient(135deg,#020104,#0b0511,#2e1938,#455678)", "foreground": "#f2efff", "accent": "#f2efff", "muted": "#e3dcf5", "surface": "#ffffff26", "theme": "ink", "colors": ["#020104", "#0b0511", "#2e1938", "#455678"], "pattern": 18, "lightInk": true},
  "solarwindmidnight": {"name": "Solar wind midnight", "family": "space", "background": "linear-gradient(135deg,#020307,#080e1d,#1b414b,#806440)", "foreground": "#f4fbff", "accent": "#f4fbff", "muted": "#dceefa", "surface": "#ffffff26", "theme": "ink", "colors": ["#020307", "#080e1d", "#1b414b", "#806440"], "pattern": 19, "lightInk": true},
  "bluedwarfmidnight": {"name": "Blue dwarf midnight", "family": "space", "background": "linear-gradient(135deg,#000204,#040d1a,#0d405d,#5e8a98)", "foreground": "#effbff", "accent": "#effbff", "muted": "#d5edf4", "surface": "#ffffff26", "theme": "ink", "colors": ["#000204", "#040d1a", "#0d405d", "#5e8a98"], "pattern": 20, "lightInk": true},
  "horseheadmidnight": {"name": "Horsehead midnight", "family": "space", "background": "linear-gradient(135deg,#030104,#0f060e,#491c25,#874a3a)", "foreground": "#fff1ed", "accent": "#fff1ed", "muted": "#efd6d0", "surface": "#ffffff26", "theme": "ink", "colors": ["#030104", "#0f060e", "#491c25", "#874a3a"], "pattern": 21, "lightInk": true},
  "deepvoidmidnight": {"name": "Deep void midnight", "family": "space", "background": "linear-gradient(135deg,#000002,#03050f,#151e3c,#4e587c)", "foreground": "#eef1ff", "accent": "#eef1ff", "muted": "#d9def5", "surface": "#ffffff26", "theme": "ink", "colors": ["#000002", "#03050f", "#151e3c", "#4e587c"], "pattern": 22, "lightInk": true},
  "pulsarmidnight": {"name": "Pulsar midnight", "family": "space", "background": "linear-gradient(135deg,#010104,#0c0516,#321e4a,#784d82)", "foreground": "#fbf2ff", "accent": "#fbf2ff", "muted": "#ead9f1", "surface": "#ffffff26", "theme": "ink", "colors": ["#010104", "#0c0516", "#321e4a", "#784d82"], "pattern": 23, "lightInk": true}
} as const;
export type CardDesign = keyof typeof cardDesigns;
export const cardDesignIds = Object.keys(cardDesigns) as [CardDesign, ...CardDesign[]];
